export const payloadQuoteUsedTransform = (vehicle, paymentOptions, dealerInfos, token) => {
    const { lang, location, orgId, orgUnitId } = dealerInfos

    const { year, make, model, odometer, stockNumber, vehicleId, vin } = vehicle

    const {
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        purchaseMethod,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        cashDown,
        tradeIn,
        lien,
        cashPurchase: {
            sellingPrice,
            retailDetails: { total: retail },
        },
    } = paymentOptions

    return {
        lang,
        location,
        orgId,
        orgUnitId,
        token,
        payload: {
            leadId: 0,
            accountId: 0,
            year,
            make,
            model,
            vehicleCondition: vehicleCondition || 'used',
            showroomVehicleId: '',
            vehicleId,
            vin,
            stockNumber,
            retail,
            sellingPrice,
            saleType,
            taxPlan,
            odometer,
            purchaseMethod: purchaseMethod || 'cash',
            financePlan,
            kmPerYearPlan,
            paymentFrequency,
            term,
            cashDown,
            tradeIn,
            lien,
            transactionTokenCopy: transactionToken,
        },
    }
}

export const payloadQuoteNewTransform = (vehicle, paymentOptions, dealerInfos, token) => {
    const { lang, location, orgId, orgUnitId } = dealerInfos

    const { year, make, model, odometer, stockNumber, vehicleId, vin, showroomVehicleId } = vehicle

    const {
        modelTrimCode,
        configurationId,
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        purchaseMethod,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        cashDown,
        tradeIn,
        lien,
    } = paymentOptions

    return {
        showroomVehicleId,
        lang,
        location,
        orgId,
        orgUnitId,
        token,
        payload: {
            leadId: 0,
            accountId: 0,
            year,
            make,
            model,
            vehicleCondition: vehicleCondition || 'new',
            modelTrimCode,
            configurationId,
            showroomVehicleId,
            vehicleId,
            vin,
            stockNumber,
            saleType,
            taxPlan,
            odometer,
            purchaseMethod: purchaseMethod || 'cash',
            financePlan,
            kmPerYearPlan,
            paymentFrequency,
            term,
            cashDown,
            tradeIn,
            lien,
            transactionTokenCopy: transactionToken,
        },
    }
}

export const payloadQuoteCatalogTransform = (vehicle, dealerInfos, token) => {
    const { lang, location, orgId, orgUnitId } = dealerInfos

    const {
        modelTrimCode,
        configurationId,
        transactionToken,
        saleType,
        taxPlan,
        vehicleCondition,
        purchaseMethod,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        cashDown,
        tradeIn,
        lien,
        year,
        make: { name: make },
        odometer,
    } = vehicle

    return {
        lang,
        location,
        orgId,
        orgUnitId,
        token,
        payload: {
            leadId: 0,
            accountId: 0,
            year,
            make,
            modelTrimCode,
            configurationId,
            transactionToken,
            saleType,
            taxPlan,
            vehicleCondition,
            odometer,
            purchaseMethod,
            financePlan,
            kmPerYearPlan,
            paymentFrequency,
            term,
            cashDown,
            tradeIn,
            lien,
            transactionTokenCopy: transactionToken,
        },
    }
}
